import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-count-indicator',
  standalone: true,
  templateUrl: './count-indicator.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './count-indicator.component.scss'
})
export class CountIndicatorComponent {
  @Input() public count: number = 0;
}
